//! Blog Index page
// *********************************************************************************** //
// * Import Styles and Material Design Component Modules                             * //
// *********************************************************************************** //
import 'normalize.css';
import '../styles/index.scss';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCRipple } from '@material/ripple';
import { MDCList } from '@material/list';
// import { MDCDialog } from '@material/dialog';
import { MDCMenuSurface } from '@material/menu-surface';
import { MDCIconButtonToggle } from '@material/icon-button';

const isProduction = process.env.NODE_ENV === 'production';
const serverUrl = isProduction ? '' : 'http://localhost:3000';
const signInPageUrl = `${serverUrl}/auth/sign-in`;

const freeAppUrl = isProduction ? '/app' : 'http://localhost:3000/app';

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// *********************************************************************************** //
// * Initialize All Buttons as Material Design Components                            * //
// *********************************************************************************** //
const buttons = document.querySelectorAll('.mdc-button');
buttons.forEach((btn) => {
  // Iterate through all buttons and attach to MDCRipple class
  const rippleButton = new MDCRipple(btn);
  rippleButton.listen('click', (event) => {
    if (event.target.classList.contains('sm')) {
      // Opens the social media icons in a new tab
      window.open(event.target.offsetParent.dataset.href, '_blank');
    }
  });
});

// *********************************************************************************** //
// * Top App Bar                                                                     * //
// *********************************************************************************** //
// Get the height of the Top App Bar component and set the padding-top for <main></main>
const topAppBar = new MDCTopAppBar(document.querySelector('.mdc-top-app-bar'));
const topAppBarHeight = topAppBar.root_.getBoundingClientRect().height;
const main = document.querySelector('#main');
main.style.paddingTop = `${topAppBarHeight + 10}px`;

// Hamburger Menu
const menuSurface = new MDCMenuSurface(document.querySelector('.mdc-menu-surface'));
const iconToggle = new MDCIconButtonToggle(document.querySelector('.mdc-icon-button.headerMenuButton'));
iconToggle.listen('click', () => {
  if (iconToggle.on) {
    menuSurface.open(true);
  } else {
    menuSurface.close();
  }
});

menuSurface.listen('MDCMenuSurface:closed', () => {
  iconToggle.on = false;
});

// Hamburger Menu list items
const list = new MDCList(document.querySelector('#menuSurfaceList'));
list.singleSelection = true;
// eslint-disable-next-line array-callback-return
list.listElements.map((listItemEl) => {
  const li = new MDCRipple(listItemEl);
  // If the user is signed in then change the text content from "Try Free App" to "Use MGRS Mapper" on page load
  if (li.root_.id === 'tryFreeAppButtonOnSurfaceMenu' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.innerHTML = `
      <svg height="24px" width="24px" preserveAspectRatio="xMidYMid" viewBox="21 46 158 108" xmlns="http://www.w3.org/2000/svg">
        <path stroke="#000" stroke-width="4" d="M25 50h150v100H25z" fill="#80E0FF" />
        <path d="M25 150L175 50" fill="none" stroke="#000" stroke-width="4" />
      </svg>
      <span class="mdc-list-item__text">
        Use MGRS Mapper
      </span>`;
  }
  // If the user is signed in then hide the login button
  if (li.root_.id === 'loginButtonOnSurfaceMenu' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.style.display = 'none';
  }
  // If the user is signed in then hide the Join Premium list item
  if (li.root_.id === 'joinPremium' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.style.display = 'none';
  }

  li.listen('click', () => {
    if (li.root_.id === 'returnHome') {
      window.location = isProduction ? '/' : 'http://localhost:3030';
      return;
    }
    if (li.root_.id === 'blogIndex') {
      window.location = isProduction ? '/blog' : 'http://localhost:3040/blog';
      return;
    }
    if (li.root_.id === 'quizIndex') {
      window.location = isProduction ? '/quiz' : 'http://localhost:3050/quiz';
      return;
    }
    // Log the user in if he clicks on the login button on the surface menu for the Top App Bar
    if (li.root_.id === 'loginButtonOnSurfaceMenu') {
      console.log('Login into the application from Hamburger Surface Menu');
      if (isProduction) {
        // GA Event: Login button on Surface Menu
        window.gtag('event', 'login', {
          event_category: 'sales_page_login',
          event_label: 'surface_menu',
        });
      }
      window.location = signInPageUrl;
      return;
    }
    if (li.root_.id === 'tryFreeAppButtonOnSurfaceMenu') {
      console.log('Try free app from Surface Menu');
      if (isProduction) {
        // GA Event: Try free app from Surface Menu
        window.gtag('event', 'view_item', {
          event_category: 'sales_page_free_app',
          event_label: 'surface_menu',
        });
      }
      window.location = freeAppUrl;
      return;
    }
    if (li.root_.id === 'joinPremium') {
      window.location = signInPageUrl;
    }
  });
});

// *********************************************************************************** //
// * Blog Articles                                                                   * //
// *********************************************************************************** //
// Index page sidebar
const blogArticleList = new MDCList(document.querySelector('.mdc-list.mdc-list--two-line.blogArticleList'));
blogArticleList.listElements.forEach((listItemEl) => {
  const blogArticleListItem = new MDCRipple(listItemEl);
  blogArticleListItem.listen('click', (event) => {
    const elements = document.elementsFromPoint(event.clientX, event.clientY);
    const chosenTarget = elements.find((key) => key.matches('li'));
    document.location.href = chosenTarget.querySelector('a').getAttribute('href');
  });
});

// Change page location when a user clicks on an article
const articles = document.querySelectorAll('article');
articles.forEach((article) => {
  article.addEventListener('click', (event) => {
    const elements = document.elementsFromPoint(event.clientX, event.clientY);
    const chosenTarget = elements.find((key) => key.matches('article'));
    document.location.href = chosenTarget.querySelector('a').getAttribute('href');
  });
});
